import { mapState, mapActions, mapMutations, mapGetters } from 'vuex';
import actions from './actions';
import state from './state';
import getters from './getters';
import mutations from './mutations';

export const serviceComputed = {
	...mapGetters('userEmailPopupStore', Object.keys(getters)),
	...mapState('userEmailPopupStore', Object.keys(state))
};
export const serviceMethods = {
	...mapActions('userEmailPopupStore', Object.keys(actions)),
	...mapMutations('userEmailPopupStore', Object.keys(mutations))
};
